import { HttpParams } from '@angular/common/http'
import { Component, WritableSignal, effect, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellType, DataMap, GridPanel } from '@grapecity/wijmo.grid'

import { BaseComponent, Grid, ListItem, ModalSize, SchedulingJob, SchedulingTransport, VpUser } from '../../../shared'
import { ActionToolbarButtonsComponent } from '../../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'
import { SchedulingTransportComponent } from './transport.component'

@Component({
    selector: 'app-scheduling-transports',
    templateUrl: './transports.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        ActionToolbarButtonsComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SchedulingTransportsComponent extends BaseComponent {
    active = input(0)
    faSearch = faSearch
    grid: Grid<any>

    priorityList = [new ListItem(1, 'High'), new ListItem(2, 'Medium'), new ListItem(3, 'Low')]
    priorityMap = new DataMap(this.priorityList, 'value', 'display')

    jobs = input<WritableSignal<SchedulingJob[]>>()
    jobList: ListItem<string>[] = []
    jobMap!: DataMap<string>

    allUserMap!: DataMap
    activeUserMap!: DataMap

    constructor() {
        super()

        this.grid = new Grid<any>(this.services, 'id', this)
            .setupModalEditing(
                this.services.data.schedulingTransports,
                'Transport',
                SchedulingTransportComponent,
                () => new SchedulingTransport(),
                this,
                ModalSize.large,
            )
            .filterBy(item => [item.job])
            .wrapColumnHeaders()

        effect(() => {
            if (this.active() == -4 && this.isInitialLoading) {
                this.refresh()
            }
        })

        effect(() => {
            const jobs = this.jobs()
            if (!jobs) return
            const jobList = jobs().map(x => new ListItem(x.job, x.jobName))
            jobList.unshift(new ListItem('VanCon HQ / Shop', 'VanCon HQ / Shop'))
            this.jobList = jobList
            this.jobMap = new DataMap(jobList, 'value', 'display')
        })
    }

    refresh() {
        this.cancelableRequest(
            'transports',
            true,
            this.services.data
                .load(
                    this.active() === -4,
                    true,
                    this.services.data.schedulingTransports.queryAll(),
                    this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', false)),
                    this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', true)),
                )
                .subscribe({
                    next: result => {
                        this.grid.items = result[0]

                        // We want the grid to show a value for any user, even inactive ones.
                        this.allUserMap = new DataMap(result[1] as VpUser[], 'id', 'name')

                        // When the grid is edited, we will only show active users as options.
                        this.activeUserMap = new DataMap(result[2] as VpUser[], 'id', 'name')

                        this.initialLoadingComplete()
                    },
                }),
        )
    }

    itemFormatter = (panel: GridPanel, r, c, cell: HTMLDivElement) => {
        if (panel.cellType === CellType.Cell) {
            const row = panel.grid.rows[r]
            const dataItem = row.dataItem as SchedulingTransport
            cell.style.textDecoration = 'unset'
            if (dataItem && dataItem.completionDate != null) {
                cell.style.textDecoration = 'line-through'
            }
        }
    }
}
